<template>
  <div >
    <div class="row">
      <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
          <div class="card-header p-primary bg-transparent">
            <h5 class="card-title d-inline-block mb-0">{{ title }}</h5>
          </div>
          <div class="card-body">
            <el-form v-if="active === 1"> 
                <form
                    class="mb-0"
                    :class="{ 'loading-opacity': preloader }"
                    ref="form"
                    :data-url="addUrl">
                    <div class="form-group row align-items-center">
                        <label for="inputs_name" class="col-sm-3 mb-0">
                            {{ $t("title") }}
                        </label>
                        <app-input
                            id="inputs_name"
                            class="col-sm-9"
                            type="text"
                            v-model="inputs.name"
                            :required="true"
                        />
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="inputs_email" class="col-sm-3 mb-0">
                            {{ $t("description") }}
                        </label>
                        <app-input
                            id="inputs_email"
                            class="col-sm-9"
                            type="textarea"
                            v-model="inputs.description"
                            :required="true"
                        />
                    </div>
                    <div class="form-group row align-items-center">
                        <div class="col-sm-3 mb-3">
                            <label for="inputs_category" >
                            {{ $t("category") }}
                            </label>
                        </div>
                        <div class="col-sm-9">
                            <app-input
                            id="inputs_category"
                            type="search-select"
                            :placeholder="$t('select_category')"
                            v-model="inputs.business_category_id"
                            :list="category"
                            />
                            <p class="font-italic text-muted">
                            {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                            </p>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t("save_in") }}
                    </label>
                    <app-input
                        class="mt-2 pt-1 col-sm-9"
                        type="radio"
                        :list="parentradio"
                        v-model="inputs.is_parent"
                        :required="true"
                    />
                    </div>
                    <div
                    class="form-group row align-items-center"
                    v-if="inputs.is_parent === '0'"
                    >
                      <div class="col-sm-3 mb-0">
                        <label for="inputs_status">
                          {{ $t("select_folder") }}
                        </label>
                      </div>
                      <div class="col-sm-9">
                        <app-input
                          :list="this.parentList"
                          type="search-select"
                          :placeholder="$t('select_folder')"
                          v-model="inputs.select_parent"
                        />
                        <p class="font-italic text-muted">
                          {{ $t("shortcut_folder_create") }} <span><a href="#" @click.prevent="CreateEditFolderModal()">{{$t("create_folder")}}</a></span>
                        </p>
                      </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="inputs_email" class="col-sm-3 mb-0">
                            {{ $t("is_public") }}
                        </label>
                        <app-input
                            class="mt-2 pt-1 col-sm-9"
                            type="radio"
                            :list="publicradio"
                            v-model="inputs.is_public"
                            :required="true"
                        />
                    </div>
                    <div class="row mt-2 text-right" >
                        <div class="col-md-12">
                            <button class="btn btn-secondary" @click.prevent="backScreen()">{{$t('cancel')}}</button>
                            <button class="btn btn-primary" @click.prevent="submit()">{{$t('save')}}</button>
                        </div>
                    </div>
                </form>
            </el-form>
            <el-form v-if="active === 2"> 
                <documentlibrary-add-category :back='closeCategory'></documentlibrary-add-category>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <category-addmodal
      v-if="isAddModalActive"
      @close-modal="closeCategory"
    />

    <documentlibrary-AddUpdateFolderModal
      v-if="isAddEditFolderModalActive"
      :refresh="loadDocuments"
      :type="type"
      :selected-url="selectedUrl"
      :selected-id ="selectedId"
      @close-modal="closeAddEditFolderModal"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import * as actions from "../../../../Config/ApiUrl";
export default {
  name: "SetFormInformation",
  mixins: [FormMixin],
  props: {
    type: String,
    back: Function,
    isUseTemplate: {type:Boolean, default: false},
    useTemplateData: {},
  },
  data() {
    return {
      title: 'Set Form Information',
      addUrl: actions.FORMS_POST,
      active: 1,
      category: [],
      parentradio: [
        { id: "1", value: "Yes" },
        { id: "0", value: "No" },
      ],
      publicradio: [
        { id: "1", value: "Yes" },
        { id: "0", value: "No" },
      ],
      preloader: false,
      inputs: {
        is_parent: "1",
        is_use_template: false,
      },
      parentList: [],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      isAddEditFolderModalActive: false,
    };
  },
  created() {
    if (this.isUseTemplate == true) {
        this.setUseTemplate();
    }
    this.getCategories();
  },
  methods: {
    addCategory() {
      this.title = 'Add Category';
      this.active = 2;
    },
    closeCategory(value) {
      this.title = 'Set Form Information',
      this.active = value;
      this.getCategories();
    },
    getCategories() {
      axiosGet(actions.CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.inputs.type = this.type;
      this.inputs.is_file_folder = 'file';
      this.inputs.parent_id = this.inputs.select_parent;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if(this.isUseTemplate == true){
        let useTemplateId = this.useTemplateData.id;
        this.$emit('view',response.data.form_id, useTemplateId, this.isUseTemplate);
      }
      else {
        this.$emit('view',response.data.form_id);
      }
      this.$toastr.s(response.data.message);
    },
    backScreen() {
      this.back();
    },
    getparent() {
      let url = this.type == 'questionnaire' ? actions.FORMS_GET_PARENT+'?form_type='+this.type : actions.FORMS_GET_PARENT;
      axiosGet(url)
        .then((res) => {
          this.parentList = res.data;
        })
        .catch((error) => {
          
        });
    },
    CreateEditFolderModal() {
      this.isAddEditFolderModalActive = true;
    },
    closeAddEditFolderModal() {
      $("#demo-add-edit-folder-Modal").modal("hide");
        this.isAddEditFolderModalActive = false;
        this.getparent();
    },
    setUseTemplate() {
      this.inputs.name = this.useTemplateData.name;
      this.inputs.description = this.useTemplateData.description;
      this.inputs.import_form_id = this.useTemplateData.id;
      this.inputs.business_category_id = this.useTemplateData.business_category_id;
      this.inputs.is_use_template = true;
    }
  },
  mounted() {
    this.getparent();
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
